export class RandomUtil {
    constructor() {
    }
    static generateId() {
        return (Math.random() * 1e64).toString(36).substr(0, 15);
    }
}
//# sourceMappingURL=random-util.js.map